import { ApiData } from '../../models';

export const orNew = <T, U = Record<string, unknown>>(data: ApiData<T, U>): ApiData<T, U> => data || new ApiData<T, U>();
export const asData = <T, U>(data: T): ApiData<T, U> => new ApiData<T, U>().succeeded(data);
